import { render, staticRenderFns } from "./freightRules.vue?vue&type=template&id=8e4c646c&scoped=true&"
import script from "./freightRules.vue?vue&type=script&lang=js&"
export * from "./freightRules.vue?vue&type=script&lang=js&"
import style0 from "./freightRules.vue?vue&type=style&index=0&id=8e4c646c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4c646c",
  null
  
)

export default component.exports